import { defineRouting } from 'next-intl/routing';
import { createNavigation } from 'next-intl/navigation';

// Tri-lingual: Traditional Chinese (base) / English / Vietnamese.
// 'as-needed': the default locale (zh-Hant) drops its URL prefix — clean
// /login, /market for the Taiwan-first launch; /en/… only if re-enabled.
export const routing = defineRouting({
  locales: ['zh-Hant', 'en', 'vi'],
  defaultLocale: 'zh-Hant',
  localePrefix: 'as-needed',
});

export type AppLocale = (typeof routing.locales)[number];

export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);
